import React from 'react';

import TwitterShareSvg from 'assets/images/twitter-share.svg';

import BaseIcon from './BaseIcon';

const TwitterShareIcon = props => <BaseIcon {...props} src={TwitterShareSvg} />;

export default TwitterShareIcon;
